module.exports = __webpack_public_path__ + "static/media/eight-ball-header-side.c2d93780.png";